// /* eslint-disable no-unused-vars */

/* eslint-disable complexity */
import React, { useCallback, useEffect, useState } from 'react';
// import Policy from 'app/components/policies';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { Box, Divider, IconButton, Stack, Grid, Button, Typography } from '@mui/material';
import { Toast } from 'app/components';
import FlashIcon from 'app/components/Svgs/FlashIcon';
import FlashOffIcon from 'app/components/Svgs/FlashOffIcon';
import { PolicyTable, Alert, Loader } from 'app/components/v2';
import CreatePolicyModal from 'app/components/v2/createPolicy';
import {
  ActivePolicyContainer,
  ChildGrid,
  Container,
  ParentGrid,
  PolicyContainer,
  PolicyContainerDesc,
  PolicyContainerTitle,
  PolicySubContainer,
  PolicySubContainerNormalText,
  SubContainer,
  SubNav,
} from './style';
import {
  createWithTemplate,
  getPolicyById,
  setChanges,
  setPrivacyPersistedError,
} from 'app/store/features/privacyPersistedSlice';
import {
  deletePolicyByID,
  getAllPolicies,
  getAllPoliciesTypes,
  getPolicyTemplateTypes,
  deletePolicyByCache,
  getUsers,
  setPrivacyError,
  activateOrDeactivatePolicy,
} from 'app/store/features/privacySlice';
import { setAlertOpen } from 'app/store/features/toggleSidebarSlice';
import { ColorsV2 } from 'app/constants/color';
import { DEFAULT_POLICY, DEFAULT_POLICY_VALUE } from 'app/utils/constants';
import { parseAndFormatDate } from 'app/utils';
import NoData from '../insights/compliance/NoData';
import { Buttons } from 'app/constants/sizing';

const Privacy = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(null);
  const [message, setMessage] = useState({ text: '', severity: 'success' });
  const [messageOpen, setMessageOpen] = useState(false);
  const [openCreateModel, setOpenCreateModel] = useState(false);
  const [createPolicyPayload, setCreatePolicyPayload] = useState({
    name: '',
    templateId: '',
  });
  const [openModel, setOpenModel] = useState({
    open: false,
    callingButton: '',
    confirmationMessage: '',
  });

  // const token =
  //   localStorage.getItem('object') &&
  //   (JSON.parse(localStorage.getItem('object')) ||
  //     JSON.parse(localStorage.getItem('object')).accessToken);

  const { id: userId, fname, lname } = {userId: '', fname: '', lname: ''}; // Placeholder, replace with real account data fetched from .../account
  const { t } = useTranslation('translation', { keyPrefix: 'policy_manager' });
  const activePolicy = [];

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const open = useSelector(state => state.privacyPagePermission.isCreatePolicyModelVisible);
  const visibility = useSelector(state => state.privacyPagePermission.CreateFromTemplate);

  const {
    allPolicies = DEFAULT_POLICY_VALUE,
    privacyError,
    policyTypes = [],
    loading,
    users,
    statuses,
    isPolicyTypesFetched,
    areUsersFetched,
  } = useSelector(state => state.privacy);

  const { createdPolicy, changes, privacyPersistedError } = useSelector(
    state => state.privacyPersisted
  );
  const fetchPolicyTypesFunc = useCallback(() => {
    dispatch(getAllPoliciesTypes());
    dispatch(getAllPolicies());
    dispatch(getPolicyTemplateTypes(DEFAULT_POLICY));
    if (!areUsersFetched) {
      dispatch(getUsers());
    }
  }, [policyTypes?.[0]?.id]);

  useEffect(() => {
    fetchPolicyTypesFunc();
    dispatch(setChanges(false));
    dispatch(setAlertOpen(false));
    if (createdPolicy?.policyType && changes) {
      dispatch(deletePolicyByCache(createdPolicy?.policyType));
    }
  }, []);

  useEffect(() => {
    if (privacyError) {
      setMessage({
        text: privacyError.hint || t('policy_locked_by_user'),
        severity: 'error',
      });
      setMessageOpen(true);
    }
    if (privacyPersistedError) {
      setMessage({
        text: privacyPersistedError.hint || t('policy_locked_by_user'),
        severity: 'error',
      });
      setMessageOpen(true);
    }
  }, [privacyError, privacyPersistedError]);

  useEffect(() => {
    if (allPolicies?.id) {
      const filtered = users?.find(item => item.id === allPolicies?.lockedBy);
      setData(filtered);
    }
  }, [users, allPolicies]);

  const handleNavigate = (templateId, action) => {
    if (templateId) {
      navigate('/board/template', { state: { action } });
    } else {
      navigate('/board/blank', { state: { action } });
    }
  };

  const handlePolicyCreation = (data = createPolicyPayload) => {
    dispatch(
      createWithTemplate({
        policyTypeId: DEFAULT_POLICY,
        templateId: data.templateId,
        name: `${data.name}`,
      })
    ).then(res => {
      if (!res.error) {
        localStorage.setItem('policyType', allPolicies.policyType);
        handleNavigate(res.payload.templateId, 'CREATE');
      }
    });
  };

  const handleDeletePolicy = shouldCreatePolicy => {
    dispatch(deletePolicyByID({ id: allPolicies?.policyType })).then(res => {
      if (!shouldCreatePolicy) {
        dispatch(getAllPolicies());
      }
      if (!res.error && shouldCreatePolicy) {
        handlePolicyCreation();
      }
    });
  };

  const handleEditAndView = ({readOnly = true}) => {
    dispatch(getPolicyById({ id: allPolicies.policyType, readOnly })).then(res => {
      if (!res.error) {
        localStorage.setItem('policyType', allPolicies.policyType);
        handleNavigate(res.payload.templateId, readOnly ? 'VIEW' : 'EDIT');
      }
    });
  };

  const resetOpenModal = () => {
    setOpenModel({
      open: false,
      callingButton: '',
      confirmationMessage: '',
    });
  };

  const handleDeletionConfirmation = () => {
    resetOpenModal();
    if (openModel.callingButton === 'DELETE') {
      handleDeletePolicy(false);
      return;
    }
    handleDeletePolicy(true);
  };

  const handleCreatePolicy = data => {
    if (allPolicies.lastSaved) {
      setOpenModel({
        open: true,
        callingButton: 'CREATE',
        confirmationMessage: t('delete_policy_conformation_text'),
      });
      setCreatePolicyPayload(data);
    } else {
      handlePolicyCreation(data);
    }
  };

  const handleActivate = action => {
    dispatch(activateOrDeactivatePolicy({ policyType: allPolicies.policyType, action }));
  };

  const openCreateNewPolicyModel = () => {
    setOpenCreateModel(true);
  };

  const getPolicyStatus = () => {
    const { beingEdited, lastSaved } = allPolicies || {};

    const renderSavedSection = () => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='body2' sx={{ color: '#bfeb7e' }}>{t('saved')}</Typography>
        <Typography variant='body2' sx={{ color: ColorsV2.textInfo }}>
          {parseAndFormatDate(statuses['Saved']?.lastSaved, 'DD MMM YYYY HH:mm')}
        </Typography>
      </div>
    );

    const renderLockedSection = () => (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant='body2' sx={{ color: ColorsV2.textInfo }}>{t('locked')}</Typography>
        {data ? (
          <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Typography variant='body2' sx={{ color: ColorsV2.textInfo }}>
              {data.firstName + " " + data.lastName}
            </Typography>
          </span>
        ) : (
          <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Typography variant='body2' sx={{ color: ColorsV2.textInfo }}>
              {fname + " " + lname}
            </Typography>
          </span>
        )}
      </div>
    );

    const locked = true
    if(locked){
      return(
      <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant='body2' sx={{ color: ColorsV2.white }}>{t('edit_in_progress')}</Typography>
      {statuses['Saved'] && renderSavedSection()}
      {statuses['Draft'] && renderLockedSection()}
      {renderLockedSection()}
    </div>)
    }

    if (beingEdited) {
      if (!lastSaved) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ color: ColorsV2.acent }}>{t('edit_in_progress')}</Typography>
            {statuses['Draft'] && renderLockedSection()}
          </div>
        );
      } else {
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ color: ColorsV2.acent }}>{t('edit_in_progress')}</Typography>
            {statuses['Saved'] && renderSavedSection()}
            {statuses['Draft'] && renderLockedSection()}
          </div>
        );
      }
    } else {
      if (lastSaved) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {statuses['Saved'] && renderSavedSection()}
            {statuses['Draft'] && renderLockedSection()}
          </div>
        );
      } else {
        return <span> N/A</span>;
      }
    }
  };

  const handleCloseToast = () => {
    dispatch(setPrivacyError(null));
    dispatch(setPrivacyPersistedError(null));
    setMessageOpen(false);
  };

  if (!isPolicyTypesFetched) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  return (
    <Container>
      <SubContainer>
        <SubNav>
          <ParentGrid container spacing={3}>
            <ChildGrid item>
              <ActivePolicyContainer>
                <PolicyContainerTitle>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      variant='h4'
                      sx={{ color: ColorsV2.white}}
                    >
                      {t('page_heading')}
                    </Typography>
                    <Button
                      name={'IconButton'}
                      variant='outlined'
                      onClick={() => openCreateNewPolicyModel()}
                      sx={{
                        ...Buttons.baseStyle.primaryButtonLowPriority,
                      }}
                    >
                      {t('create_new')}
                    </Button>
                  </Box>

                  <Divider sx={{ bgcolor: 'white', marginY: '0.4em' }} />
                  <PolicyContainerDesc sx={{ paddingLeft: 0 }}>
                    <Typography variant='body1' sx={{color: ColorsV2.textInfo}}>
                      {t('information_and_classification_description.text_v_2')}
                    </Typography>
                    <Typography variant='body1' sx={{color: ColorsV2.textInfo}}>
                      {t('information_and_classification_description.text_2_v_2')}
                    </Typography>
                  </PolicyContainerDesc>
                </PolicyContainerTitle>
                <Box sx={{ paddingX: '20px' }}>
                  <Divider sx={{ bgcolor: 'white', marginY: '0.4em' }} />
                </Box>{' '}
                <PolicyContainer sx={{ height: !activePolicy && 'auto' }}>
                  <Box sx={{ padding: '1.2em 0.9em 0 0.9em' }}>
                    {!allPolicies.id ? (
                      <Box
                        height={'25vh'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                      >
                        <NoData />
                      </Box>
                    ) : (
                      <>
                        {allPolicies.isActive ? (
                          <>
                            <Box
                              sx={{
                                backgroundColor: 'ColorsV2.secondary',
                                border: `2px solid ${ColorsV2.outline}`,
                                borderRadius: '4px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                paddingY: 2,
                                paddingLeft: 1,
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={3} sx={{ border: 0}}>
                                  <Typography variant='body1' sx={{color: ColorsV2.white}}>
                                    {t('status_current')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0}}>
                                  <Typography variant='body1' sx={{color: ColorsV2.white}}>
                                    {t('policy_name')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0}}>
                                  <Typography variant='body1' sx={{color: ColorsV2.white}}>
                                    {t('description')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0 }}>
                                  <Typography variant='body1' sx={{color: ColorsV2.white}}>
                                    {t('actions')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                              </Grid>
                              <Grid container spacing={2} sx={{ '& td': { border: 0 } }}>
                                <Grid item xs={3} sx={{ padding: '0 16px 16px 16px' }}>
                                  <PolicySubContainerNormalText>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <FlashIcon stroke={ColorsV2.white} />
                                      <Typography variant='body2' sx={{color: ColorsV2.white}}>{t('policy_active')}</Typography>
                                    </Box>
                                  </PolicySubContainerNormalText>
                                  <Typography variant='body2' sx={{color: ColorsV2.textInfo}}
                                  >
                                    {t('since')}{' '}
                                    {parseAndFormatDate(
                                      allPolicies?.activationDates[0],
                                      'DD MMM YYYY HH:mm'
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                >
                                  <Typography variant='body2' sx={{color: ColorsV2.textInfo}}>
                                  {statuses['Active']?.name || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                >
                                  <Typography variant='body2' sx={{color: ColorsV2.textInfo, textOverflow: 'ellipsis', }}>
                                    {statuses['Active']?.comment}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{ padding: '0 16px 16px 16px' }}
                                  align='right'
                                >
                                  <Stack
                                    direction='column'
                                    spacing={1}
                                    sx={{ width: 'max-content', justifyContent: 'end', ml: 'auto' }}
                                  >
                                    <Button
                                      id={!visibility && !open ? 'step-1' : ''}
                                      name={'LoadingButton'}
                                      loadingPosition={'start'}
                                      loading={loading}
                                      onClick={() => handleActivate(!allPolicies.isActive)}
                                      disabled={
                                        allPolicies &&
                                        allPolicies?.lockedBy &&
                                        allPolicies?.lockedBy !== userId
                                      }
                                      startIcon={<FlashOffIcon fill={ColorsV2.white} />}
                                      sx={{ ...Buttons.baseStyle.primaryButtonLowPriority, }}
                                    >
                                      {t('deactivate')}
                                    </Button>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </Box>
                          </>
                        ) : (
                          ''
                        )}

                        {allPolicies?.activationDates?.length ? (
                          <>
                            <Box
                              sx={{
                                // width: 'maxContent',
                                display: 'flex',
                                flexDirection: 'column',
                                // alignItems: 'center',
                                // height: 'maxContent',
                                mt: '20px',
                                mb: '10px',
                              }}
                            >
                              <Box
                                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                              >
                                <IconButton
                                  onClick={() => {
                                    setVisible(!visible);
                                  }}
                                >
                                  {visible ? (
                                    <KeyboardArrowUpOutlinedIcon sx={{ color: ColorsV2.white }} />
                                  ) : (
                                    <KeyboardArrowDownOutlinedIcon sx={{ color: ColorsV2.white }} />
                                  )}
                                </IconButton>
                                <Typography
                                  variant='h6'
                                  sx={{ color: ColorsV2.white }}
                                >
                                  {t('activation_history')}
                                </Typography>
                              </Box>
                            </Box>

                            <PolicySubContainer
                              sx={{
                                display: visible ? 'flex' : 'none',
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                marginBottom: '20px',
                                // marginLeft: '20px',
                                flexDirection: 'column',
                                maxHeight: '500px',
                                overflowY: 'scroll',
                              }}
                            >
                              <Typography variant='subtitle1' sx={{color: ColorsV2.textInfo}}>
                                {t('activation_subtext')}
                              </Typography>
                              <PolicyTable />
                            </PolicySubContainer>
                          </>
                        ) : (
                          ''
                        )}

                        {allPolicies?.beingEdited || statuses['Draft'] || statuses['Saved'] ? (
                          <>
                            <Divider
                              sx={{
                                width: '100%',
                                background: ColorsV2.white,
                                marginBlock: '20px',
                              }}
                            />
                            <Box
                              sx={{
                                // width: 'maxContent',
                                display: 'flex',
                                flexDirection: 'column',
                                // alignItems: 'center',
                                // height: 'maxContent',
                                mt: '20px',
                                mb: '10px',
                              }}
                            >
                                <Typography
                                  variant='h6'
                                  sx={{
                                    color: ColorsV2.white
                                  }}
                                >
                                {t('wip_header')}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                backgroundColor: ColorsV2.secondary,
                                border: `2px solid ${ColorsV2.outline}`,
                                borderRadius: '4px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                paddingY: 2,
                                paddingLeft: 1,
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={3} sx={{ border: 0, color: ColorsV2.white }}>
                                  <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                                    {t('draft_status')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0, color: ColorsV2.white }}>
                                  <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                                    {t('policy_name')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0, color: ColorsV2.white }}>
                                  <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                                    {t('description')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                                <Grid item xs={3} sx={{ border: 0, color: ColorsV2.white }}>
                                  <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                                    {t('actions')}
                                  </Typography>
                                  <Divider sx={{ bgcolor: 'white' }} />
                                </Grid>
                              </Grid>

                              <Grid container spacing={2} sx={{ '& td': { border: 0 } }}>
                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    padding: '0',
                                    verticalAlign: 'sub',
                                  }}
                                >
                                  <Box>{getPolicyStatus()}</Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                >
                                  <Typography variant='body2' sx={{color: ColorsV2.textInfo}}>
                                    {statuses['Draft']
                                    ? statuses['Draft']?.name
                                    : statuses['Saved']?.name || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                >
                                  <Typography variant='body2' sx={{color: ColorsV2.textInfo}}>
                                    {statuses['Draft']
                                    ? statuses['Draft']?.comment
                                    : statuses['Saved']?.comment}
                                  </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ padding: '0 8px 16px 16px' }}>
                                 <Stack direction='row' justifyContent='flex-end' alignItems='center' gap={1} sx={{flexWrap: 'wrap'}}>
                                    <Button
                                      name={'LoadingButton'}
                                      loading={loading}
                                      loadingPosition={'start'}
                                      onClick={() => handleEditAndView({readOnly: false})}
                                      disabled={data?.id}
                                      sx={{
                                        ...Buttons.baseStyle.primaryButtonLowPriority,
                                      }}
                                    >
                                      {t('edit')}
                                    </Button>
                                    <Button
                                      name={'LoadingButton'}
                                      loading={loading}
                                      loadingPosition={'start'}
                                      onClick={() => handleEditAndView({readOnly: true})}
                                      disabled={data?.id}
                                      sx={{
                                        ...Buttons.baseStyle.primaryButtonLowPriority,
                                      }}
                                    >
                                      {t('view')}
                                    </Button>
                                    <Button
                                      name={'LoadingButton'}
                                      loading={loading}
                                      loadingPosition={'start'}
                                      onClick={() =>
                                        setOpenModel({
                                          callingButton: 'DELETE',
                                          open: true,
                                          confirmationMessage: t(
                                            'delete_policy_conformation_text'
                                          ),
                                        })
                                      }
                                      disabled={data?.id}
                                      sx={{
                                        ...Buttons.baseStyle.primaryButtonLowPriority,
                                      }}
                                    >
                                      {t('delete')}
                                    </Button>
                                    <Button
                                      name={'LoadingButton'}
                                      loading={loading}
                                      loadingPosition={'start'}
                                      onClick={() => handleActivate(true)}
                                      disabled={
                                        allPolicies.beingEdited ||
                                        allPolicies.isActive ||
                                        !allPolicies.lastSaved
                                      }
                                      sx={{
                                        ...Buttons.baseStyle.primaryButtonLowPriority,
                                      }}
                                      startIcon={
                                        <FlashIcon stroke={ColorsV2.white} fontSize={'0.5rem'} />
                                      }
                                    >
                                      {t('activate')}
                                    </Button>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </Box>
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    )}
                  </Box>
                </PolicyContainer>
              </ActivePolicyContainer>
            </ChildGrid>
          </ParentGrid>
        </SubNav>
      </SubContainer>

      <Alert
        open={openModel.open}
        title={t('delete_policy')}
        text={openModel.confirmationMessage}
        setOpen={setOpenModel}
        handleConfirmation={handleDeletionConfirmation}
      />

      <Toast
        open={messageOpen}
        setOpen={handleCloseToast}
        message={message.text}
        severity={message.severity}
      />

      {openCreateModel && (
        <CreatePolicyModal setOpen={setOpenCreateModel} handleCreatePolicy={handleCreatePolicy} />
      )}
      {/* <Tour /> */}
    </Container>
  );
};

export default Privacy;
